<template>
     <a-config-provider :locale="language === 'English' ? enUS : zhCN">
    <div class="w-full flex" style="color: #fff;">
        <!-- 左侧 -->
        <div style="width: 270px;">
            <div class="w-full box p-2" style="width: 270px;">
                <a-radio-group v-model:value="searchModel.type" style="width: 100%;" @change="init">
                    <a-radio v-for="(item, index) in typeList" :key="index" style="display: block;" :value="item.value">{{ item.label }}</a-radio>
                </a-radio-group>
            </div>

            <div class="box mt-4" style="width: 270px;">
                <a-table 
                    style="width: 100%;" 
                    size="small" 
                    :row-class-name="getRowClassName" 
                    :columns="columns" 
                    :data-source="dataList"
                    :pagination="pagination"
                    @change="handleTableChange"
                    :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, hideSelectAll: true }"
                    rowKey="_id"
                >
                    <template #bodyCell="{ column, text }">
                        <template v-if="column.dataIndex === 'opt'">
                            <a style="color: #00d1c7ff !important">{{langObj['下载']}}</a>
                        </template>
                        <template v-if="column.dataIndex === 'date'">
                            {{ transformLocalDate(text) }}
                            </template>
                        <template v-if="column.dataIndex === 'value'">
                            <span v-if="text || text==0"> {{ text.toFixed(2) }}</span>
                        </template>
                    </template>
                </a-table>
            </div>

        </div>

        <!-- 右侧 -->
        <div class="flex-1 box ml-4 p-3">
            <div v-if="visible" id="chart7" style="width: 100%; height: 500px;"></div>
        </div>

    </div>
</a-config-provider>
</template>
<script lang="ts" setup>
import { computed, defineComponent, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
import request from "../../../common/request";
import { transformDate2, transformDate, transformBeiJingDate, transformLocalDate } from "../../../common/tools";
import { v4 as uuidv4 } from "uuid";
import * as echarts from 'echarts';
import { langList } from "../../../common/lang";
import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";

let langObj: any = ref({})
let language: any = ref('English')
const getLang = () => {
     language.value = 'English'
    langObj.value = langList[language.value]
}
 getLang()
let typeList = [
  { label: langObj.value["高频加速度(长)"], value: 2, type: "TW", unit: "m/s²" },
  { label: langObj.value["高频加速度"], value: 1, type: "HZ", unit: "m/s²" },
  // {label : '温度', value: 2},
  { label: langObj.value["低频加速度X"], value: 3, type: "LX", unit: "m/s²" },
  { label: langObj.value["低频加速度Y"], value: 4, type: "LY", unit: "m/s²" },
  { label: langObj.value["低频加速度Z"], value: 5, type: "LZ", unit: "m/s²" },
  { label: langObj.value["速度X"], value: 6, type: "SX", unit: "mm/s" },
  { label: langObj.value["速度Y"], value: 7, type: "SY", unit: "mm/s" },
  { label: langObj.value["速度Z"], value: 8, type: "SZ", unit: "mm/s" },
];



const columns = [
{
    title: langObj.value["时间"],
    dataIndex: "date",
  },
  {
    title: langObj.value["值"],
    dataIndex: "value",
  },
];


let dataList:any = ref([])
let chartA:any 
let visible = ref(true)

const props:any = defineProps({
    sensorInfo: null,
});
let sensorInfo:any = ref()
sensorInfo.value = props.sensorInfo
const pagination = computed(() => ({
  total: searchModel.value.total,
  current: searchModel.value.skip,
  pageSize: searchModel.value.take,
}));
let searchModel:any = ref({
    skip: 1,
    take: 20,
    total: 0,
    type: 1,
})
watch(
    () => props.sensorInfo,
    (newValue, oldValue) => {
        sensorInfo.value = props.sensorInfo
        init();
    }
);

onMounted(() => {
    init()
})

const init = () => {
    if(!sensorInfo.value || !sensorInfo.value.id) return
    getTrendListAll()
}

let selectedRowKeys:any = ref([])
const onSelectChange = (ev:any) => {
    if(ev.length) {
        selectedRowKeys.value = [ ev[ev.length-1] ]
    } else {
        selectedRowKeys.value = []
    }
    getChartData()
}


const getRowClassName = (record:any, index:any) => {
    // 根据索引设置不同的类名
    return index % 2 === 0 ? 'even-row' : 'odd-row';
}

const handleTableChange = (pagination: any) => {
    // 处理分页数据
    searchModel.value.skip = pagination.current
    searchModel.value.take = pagination.pageSize
    getTrendListAll();
};

//获取所有时间点数据
const getTrendListAll = async() => {
    dataList.value = []
    selectedRowKeys.value = []
    let config: any = {
        params: {
            machineId: sensorInfo.value.machineId ,
            sensorId: sensorInfo.value.id ,
            skip: searchModel.value.skip,
            take: searchModel.value.take,
            begin: transformDate(new Date('2021/01/01 00:00:00')),
            end: transformDate(transformBeiJingDate(new Date())),
            type: typeList.find((p:any) => p.value === searchModel.value.type)?.type
        },
        headers: {
            requestId: uuidv4(),
        },
    }; 

    let result = await request.get('/api/external/singles', config)

    if(result && result.data) {
        dataList.value = result.data.list
        searchModel.value.total = result.data.count
        // if(dataList.value.length) {
        //     selectedRowKeys.value = [dataList.value[0]._id]
        //     getChartData()
        // }
    }
}

const getChartData = async() => {
    if(selectedRowKeys.value.length) {
        let info = dataList.value.find((p:any) => p._id === selectedRowKeys.value[0])
        let config: any = {
            params: {
                sensorId: info.sensorId ,
                date: info.date,
                type: typeList.find((p:any) => p.value === searchModel.value.type)?.type,
            },
            headers: {
                requestId: uuidv4(),
            },
        }; 
        let result = await request.get('/api/external/singles/info', config)
        if(result && result.data && result.data.url) {
            let res = await request.post('/draw/api/ceps', {url:  [result.data.url]})
            if(res && res.data) {
                visible.value = false
                visible.value = true
                setTimeout(() => {
                    initChart(res.data)
                }, 200);
                
            }
        }else {
            chartA && chartA.clear()
        }
       
    } else {
        chartA && chartA.clear()
    }
}

getChartData()

const initChart = (data:any) => {
    console.log(data)
    let {axisX, axisY} = data
    const ec = echarts as any;
    if(!document.getElementById('chart7')) return
    chartA = ec.init(document.getElementById('chart7'));
    console.log('chartA', chartA)
    let option = {
        color: ['#00d1c7ff'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        grid: {
            top: '8%',
        },
        toolbox: {
          trigger: 'axis'
        },
        dataZoom: [{ type: 'inside' }],
        xAxis: {
            name: '倒频率-s',
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              showMaxLabel: true
            },
            splitLine: {
              show: false,
              lineStyle: {
                opacity: 0.3
              }
            },
            data: axisX
        },
        yAxis: {
            name: '幅值-m/s²',
            type: 'value',
            splitLine: {
              show: true,
            },
        },
        series: [
            {
                data: axisY,
                type: 'line'
            }
        ]
    };

    chartA && chartA.setOption(option)
}


</script>

<style lang="less" scoped>
/deep/ .ant-picker {
  background-color: #171325ff !important ;
}

.box {
    border: 1px solid #171325ff;
    background: #171325ff;
    width: 250px;
}

.btn1 {
    padding: 3px 10px;
}

/deep/ .ant-table-tbody > tr > td {
    border: 0px
}
/deep/ .ant-table {
    color: #fff
}
/deep/ .ant-table-thead .ant-table-cell {
    background-color: #080718ff;
    color: #fff;
}

/deep/ table tbody tr:hover>td {
    background-color: #080718ff !important;
}

/deep/ .ant-table-tbody > tr > td.ant-table-cell-row-hover {
    background: #c0bfbfff !important;
}

/deep/ .ant-table-tbody > tr > td {
    transition: 0s;
}

/deep/ .ant-table-tbody > tr.ant-table-row-selected > td {
    background: transparent;
    border-color: #fff;
}

/deep/ .ant-table-empty .ant-table-tbody > tr.ant-table-placeholder {
    background: #080718ff;
}

/deep/ .ant-empty-description {
    color: #fff;
}
</style>
